var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFourZeroFour = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 85,
  height: 85,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#four-zero-four_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FCB115",
  d: "m43.626 41.969-6.76 19.998-1.69 4.789H4.475V21.689H42.5l-.282.845-6.478 19.435z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FCB115",
  d: "M80.525 21.689v45.067H41.232l1.55-4.789 8.731-25.631h-7.886l4.506-13.802.282-.845z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C19FF",
  d: "M5.883 61.966H.25v5.633h5.633zM17.15 61.966h-5.633v5.633h5.633zM28.418 61.966h-5.634v5.633h5.634z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#571DBE",
  d: "M11.517 61.966H5.884v5.633h5.633zM22.784 61.966H17.15v5.633h5.634z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C19FF",
  d: "M5.883 16.899H.25v5.633h5.633zM17.15 16.899h-5.633v5.633h5.633zM28.418 16.899h-5.634v5.633h5.634z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#571DBE",
  d: "M11.517 16.899H5.884v5.633h5.633zM22.784 16.899H17.15v5.633h5.634z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C19FF",
  d: "m36.867 61.966-1.69 4.788-.14.845h-.986v-5.633zM50.95 61.966h-5.633v5.633h5.634zM62.216 61.966h-5.633v5.633h5.633z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#571DBE",
  d: "M34.05 61.966h-5.633v5.633h5.633zM45.318 61.966v5.633h-4.366l.282-.845 1.549-4.788zM56.585 61.966H50.95v5.633h5.633z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C19FF",
  d: "M39.684 16.899h-5.633v5.633h5.633zM50.95 16.899v5.633h-2.817l.281-.845 1.69-4.788zM62.216 16.899h-5.633v5.633h5.633z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#571DBE",
  d: "M34.05 16.899h-5.633v5.633h5.633zM44.19 16.899l-1.69 4.788-.281.845h-2.535V16.9zM56.585 16.899H50.95v5.633h5.633z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C19FF",
  d: "M73.484 61.966H67.85v5.633h5.633zM84.75 61.966h-5.633v5.633h5.633z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#571DBE",
  d: "M67.85 61.966h-5.633v5.633h5.633zM79.117 61.966h-5.634v5.633h5.634z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C19FF",
  d: "M73.484 16.899H67.85v5.633h5.633zM84.75 16.899h-5.633v5.633h5.633z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#571DBE",
  d: "M67.85 16.899h-5.633v5.633h5.633zM79.117 16.899h-5.634v5.633h5.634z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "four-zero-four_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.25 0h84.5v84.5H.25z"
})))));
export default SvgFourZeroFour;